define('boxes/withdraw-box',['jquery', 'boxes/box', 'all/comeon', 'boxes/helpers/payment-helpers','boxes/events/feeEvent', 'boxes/helpers/formValidation',
    'payment/withdrawFee', 'boxes/helpers/message-popup', 'boxes/events/paymentEvent', 'boxes/helpers/box-loading', 'all/player/session', 'all/tracking-event',
    'all/pretty-links', 'payment/paymentOperationMetadata', 'all/paymentServices-toggles'], function ($, box, comeon, payments, feeEvent, formValidation, 
                                                                                                      withdrawFee, messagePopup, paymentEvent, boxLoading, 
                                                                                                      session, trackingEvent, prettyLinks, 
                                                                                                      paymentOperationMetadata, paymentServicesToggles) {
    'use strict';

    function setupControllerEventHandlers(withdrawBox) {
        withdrawFee.init(withdrawBox);
        withdrawBox.$controller.on(feeEvent.RESET_FEE, function (event, data) {
            withdrawFee.resetFees(data.selectedId, data.currency, data.formTemplateCode, data.aid);
        });

        withdrawBox.$controller.on(feeEvent.UPDATE_FEE, function (event, data) {
            withdrawFee.updateFeesBox(
                data.selectedFormMethodId,
                data.amount,
                data.selectedCurrency,
                data.formTemplateCode,
                data.aid);
        });

        withdrawBox.$controller.on(feeEvent.UPDATE_TOOLTIP, function (event, data) {
            formValidation.updateFeeTooltip(data, withdrawBox);
        });

        withdrawBox.$controller.on(paymentEvent.SHOW_FAIL_MESSAGE, function (event, failMessage) {
            boxLoading.removeLoading(withdrawBox.$box);
            showWithdrawFailMessage(withdrawBox, failMessage);
        });

        withdrawBox.$controller.on(paymentEvent.REMOVE_LOADING, function () {
            boxLoading.removeLoading(withdrawBox.$box);
        });

        withdrawBox.$controller.on(paymentEvent.SUCCESSFUL_TRANSACTION_COMPLETED, function(event) {
            event.preventDefault();
            reset(withdrawBox);
        });
    }

    function reset(withdrawBox){
        getPaymentMethodsAndInitializeBox(withdrawBox, true);
    }

    function showWithdrawFailMessage(withdrawBox, failMessage) {

        enableWithdrawButton(withdrawBox);

        function addFailedTrackingEvent(withdrawBox, selectedPaymentMethodId) {
            if(!withdrawBox.$box.data('trackingName') || !withdrawBox.$controller.$controller.data('trackingName')) {
                return;
            }

            trackingEvent.add(
                withdrawBox.$controller.$controller.data('trackingName'),
                withdrawBox.$box.data('trackingName'),
                'Withdraw failed, payment method id = ' + selectedPaymentMethodId
            );
        }
        var selectedMethodId = withdrawBox.$box.find('.payment-methods').val();
        addFailedTrackingEvent(withdrawBox, selectedMethodId);
        messagePopup.show(withdrawBox.$box,'message-popup', failMessage);
    }

    function showKYCPopupMessage(withdrawBox, popupMessage){
        var callbacks = {
            closeButtonCallback: function(e){
                e.preventDefault();
                enableWithdrawButton(withdrawBox);
            },
            confirmButtonCallback: function(e){
                e.preventDefault();
                enableWithdrawButton(withdrawBox);
                //Last minute request from business as always...
                window.location.href = prettyLinks.getLink('MyPages', 'SENDDOCUMENTS');
            }
        };
        messagePopup.show(withdrawBox.$box, 'kyc-message-popup', popupMessage,callbacks);
    }

    function setWithdrawButtonDisabled(withdrawBox, booleanDisable) { // Hungarian notation makes sense in a typeless world
        var withdrawButton = withdrawBox.$box.find('.withdraw-button');
        withdrawButton.prop('disabled', booleanDisable);
    }

    function enableWithdrawButton(withdrawBox) {
        setWithdrawButtonDisabled(withdrawBox, false);
    }

    function disableWithdrawButton(withdrawBox) {
        setWithdrawButtonDisabled(withdrawBox, true);
    }

    function setupWithdrawButton(withdrawBox) {
        var withdrawButton = withdrawBox.$box.find('.withdraw-button');
        withdrawButton.off('click').on('click', function () {
            if (formValidation.valid()) {
                disableWithdrawButton(withdrawBox);
                withdrawBox.model.paymentController.sendPayment(withdrawBox);
            }
        });
    }

    function setupUIWithdrawEventHandlers(withdrawBox) {
        enableWithdrawButton(withdrawBox);
        setupWithdrawButton(withdrawBox);
    }

    function getPaymentMethodsAndInitializeBox(withdrawBox, forceLoadInSynch) {
        var url = '/PaymentFormDataService/getWithdrawPaymentMethods';
        if (paymentServicesToggles.useOldPaymentFormFlows()) {
            url = '/pp?flow=GetWithdrawPaymentMethods';
        }
        withdrawBox.model.hasPaymentMethodsPromise = payments.getPaymentMethods('WITHDRAW', withdrawBox, url, forceLoadInSynch);
        withdrawBox.$box.find('.payment-method-form').hide();
    }

    var HTML = {method: 'html'},
        view = {
            render: function (withdrawBox) {
                withdrawBox.$box.find('.method').empty();
                var mustacheTemplateId = 'payment-method-template';
                $.Mustache.addFromDom(mustacheTemplateId);
                withdrawBox.$box.find('.method').mustache(mustacheTemplateId, {templates: withdrawBox.model.paymentController.formTemplates}, HTML);
            }
        },
        model = {
            paymentController: undefined,
            hasPaymentMethodsPromise : undefined,
            init: function (withdrawBox) {
                if(!session.authenticated){
                    $(session).on('login',function(){
                        withdrawBox.model.init(withdrawBox);
                    });
                }
                setupControllerEventHandlers(withdrawBox);
            },
            beforeRender: function (withdrawBox) {
                if(session.authenticated){
                    getPaymentMethodsAndInitializeBox(withdrawBox, false);
                }
                var hasInitSelectedFormTemplatePromise = payments.initSelectedFormTemplate(withdrawBox, withdrawBox.model.hasPaymentMethodsPromise);
                paymentOperationMetadata.queryFirstPaymentOperation('withdraw');
                return [hasInitSelectedFormTemplatePromise];
            },
            afterRender: function (withdrawBox) {
                withdrawBox.$box.find('.overlay').hide();
                payments.setupUIEventHandlers(withdrawBox);
                setupUIWithdrawEventHandlers(withdrawBox);
                payments.setupDefaultMethodDropdown(withdrawBox);
                // For now setting '' as default amount for withdraws.
                payments.setupDefaultAmountForMethod(withdrawBox);
            },
            showFailMessage: function (withdrawBox, failMessage) {
                showWithdrawFailMessage(withdrawBox, failMessage);
            },
            showKYCPopupMessage: function(withdrawBox, popupMessage){
                showKYCPopupMessage(withdrawBox,popupMessage);
            }
        };

    return {
        create: function ($box, $controller) {
            return box.create($box, $controller, view, model);
        }
    };
});

